interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

export default function LoadingSpinner({ size = 'md' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  const containerClasses = {
    sm: 'w-8 h-8',
    md: 'w-14 h-14',
    lg: 'w-20 h-20',
  };

  return (
    <div className="flex items-center justify-center">
      <div className={`${containerClasses[size]} rounded-full glass-circle-green flex items-center justify-center`}>
        <div
          className={`${sizeClasses[size]} border-2 border-plant-green-500 border-t-transparent rounded-full animate-spin`}
          style={{ boxShadow: '0 0 16px rgba(34, 197, 94, 0.25)' }}
        />
      </div>
    </div>
  );
}
